<template>
  <div class="wrapper">
    <div class="wrapper" v-for="(prop,idx) in props" :key="idx">
      <TaskFormField :prop="prop" :custprop="custprops[prop.pid]"/>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import TaskFormField from './TaskFormField.vue'

export default {
  name: 'TaskForm',
  props: ["props","custprops"],
  data() {
    return {
      uploading: false
    }
  },
  components: {
    TaskFormField,
  },
  methods: {
    readValues(upload) {
      console.log('read values');
      var data = {};
      for (var pi in this.props) {
        var p = this.props[pi];
        console.log(p);
        var elem = document.getElementById(p.pid);
        console.log(elem);

        // zusatz infos prüfen
        var cp = this.custprops[p.pid];
        if (cp && cp.type == 'smbfile' && upload) {
          console.log('upload smb file');
          // check for csv article data upload
          if (elem.files.length > 0) {
            var fd   = new FormData();
            fd.append("filename",elem.files[0]);
            var self = this;
            this.uploading = true;
            config.post(this,config.baseUrl + 'rest/smallbusiness/data','Datei Upload',fd,function(data) {
              console.log(data);
              self.uploading = false;
              self.$bvToast.toast('Upload abgeschlossen.',{variant: 'success', title: 'Dateien'});
            });
          }
        }
        console.log('elemen type:',elem);
        if (elem.type == 'checkbox') {
          data[p.pid] = elem.checked;
        } else if (elem.value && elem.value !== '')
          data[p.pid] = elem.value;
      }
      return data;
    }
  }
}
</script>
